<template>
  <div>
    <CRow class="mb-2">
      <CCol col="3" class="align-self-center">Người tạo</CCol>
      <CCol col="9">
        <vue-multiselect v-if="pathUrl !== 'by-user' && pathUrl !== 'by-me'" v-model="filter.userSelected" :options="userList"
                         placeholder="-- Chọn người tạo tin" label="name" track-by="id"
                         :custom-label="customLabelUserList" :show-labels="false"
                         :multiple="true" :taggable="true" :disabled="pathUrl === 'by-user' || pathUrl === 'by-me'"></vue-multiselect>
        <h6 v-else class="text-capitalize text-crimson my-1">{{ nameByUser }}</h6>
      </CCol>
    </CRow>
    <CRow class="mb-2">
      <CCol col="3" class="align-self-center">Loại tin</CCol>
      <CCol col="9">
        <vue-multiselect v-model="filter.statusSelected" :options="newsStatus"
                         placeholder="-- Chọn loại tin" label="name" track-by="id"
                         :multiple="true" :taggable="true"></vue-multiselect>
      </CCol>
    </CRow>
    <CRow class="mb-2">
      <CCol col="3" class="align-self-center">Trạng thái</CCol>
      <CCol col="9">
        <vue-multiselect v-model="filter.approvalStatusSelected" :options="newsApprovalStatus"
                         placeholder="-- Chọn trạng thái tin" label="name" track-by="id"
                         :multiple="true" :taggable="true"></vue-multiselect>
      </CCol>
    </CRow>
    <CRow class="mb-2">
      <CCol col="3" class="align-self-center">Kiểu hiển thị</CCol>
      <CCol col="9">
        <vue-multiselect v-model="filter.highlightSelected" :options="highlight"
                         placeholder="-- Chọn kiểu hiển thị tin" label="name" track-by="id"
                         :multiple="true" :taggable="true"></vue-multiselect>
      </CCol>
    </CRow>

    <hr/>

    <CRow class="mb-2">
      <CCol col="3" class="align-self-center">Cấp Tỉnh</CCol>
      <CCol col="9">
        <vue-multiselect v-model="filter.provinceSelected" :options="provinceList"
                         placeholder="-- Chọn cấp Tỉnh" label="name" track-by="id"
                         :multiple="true" :taggable="true"></vue-multiselect>
      </CCol>
    </CRow>
    <CRow class="mb-2">
      <CCol col="3" class="align-self-center">Cấp Huyện</CCol>
      <CCol col="9">
        <vue-multiselect v-model="filter.districtSelected" :options="districtList"
                         placeholder="-- Chọn cấp Huyện" label="name" track-by="id"
                         :multiple="true" :taggable="true"></vue-multiselect>
      </CCol>
    </CRow>
    <CRow class="mb-2">
      <CCol col="3" class="align-self-center">Cấp Xã</CCol>
      <CCol col="9">
        <vue-multiselect v-model="filter.communeSelected" :options="communeList"
                         placeholder="-- Chọn cấp Xã" label="name" track-by="id"
                         :multiple="true" :taggable="true"></vue-multiselect>
      </CCol>
    </CRow>
    <CRow class="mb-2">
      <CCol col="3" class="align-self-center">Tên quy hoạch</CCol>
      <CCol col="9">
        <vue-multiselect v-model="filter.nameSelected" :options="nameList"
                         placeholder="-- Nhập tự do (Tagging)" label="name" track-by="id"
                         :multiple="true" :taggable="true" @tag="addTag"></vue-multiselect>
      </CCol>
    </CRow>
    <CRow class="mb-2">
      <CCol col="3" class="align-self-center">Loại quy hoạch</CCol>
      <CCol col="9">
        <vue-multiselect v-model="filter.zoneTypeSelected" :options="zoneTypeList"
                         placeholder="-- Chọn loại quy hoạch" label="name" track-by="id"
                         :multiple="true" :taggable="true"></vue-multiselect>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import VueMultiselect from 'vue-multiselect'
import {filterSidebarList} from '@/mixins/zoning/filter'

export default {
  name: "FilterPanel",
  mixins: [
    filterSidebarList
  ],
  components: {
    VueMultiselect
  },
  props: {
    pathUrl: {
      type: String,
      default: ''
    },
    nameByUser: {
      type: String,
      default: ''
    }
  }
}
</script>

<style scoped></style>
